import IssueContent from './IssueContent';

export default IssueContent;
